export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'
        // text: 'NEW'
      }
    },

    {
      title: true,
      name: 'Packages',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'List Packages',
      url: '/packages',
      icon: 'icon-layers'
    },
    // {
    //   name: 'New',
    //   url: '/packages/add',
    //   icon: 'fa fa-plus-square-o'
    // },

    {
      title: true,
      name: 'Export',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Test Data Export',
      url: '/export/new',
      icon: 'icon-pencil'
    },

    {
      title: true,
      name: 'Other',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },

    // {
    //   name: 'Timeline',
    //   url: '/timeline/list',
    //   icon: 'icon-drop'
    // },
    {
      name: 'Search',
      url: '/search',
      icon: 'el-icon-search'
    },
    {
      name: 'Recently Completed',
      url: '/recent/list',
      icon: 'icon-pencil'
    },
    {
      title: true,
      name: 'Settings',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Settings',
      url: '/settings/',
      icon: 'icon-settings'
    },
    {
      title: true,
      name: 'Support',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Support Center',
      url: '/support/',
      icon: 'icon-info'
    },
    {
      name: 'Bounce Backs',
      url: '/bounces/',
      icon: 'icon-exclamation'
    } 
  ]
};
